module.exports = __webpack_public_path__ + "img/star_empty.4620cc4a.svg";